import { useState } from 'react'
import { getApi } from '@BUP/services/Axios'
import { BupError } from '@BUP/lib/errors'

export const useCreateQuestionResponse = (enrollmentId, surveyId) => {
  const [loadingResponse, setLoadingResponse] = useState(false)
  const [dataResponse, setDataResponse] = useState(null)
  const [error, setError] = useState(null)
  const saveAllResponsesByPage = async (responses) => {
    setLoadingResponse(true)
    setError(null)
    try {
      const client = await getApi('sociogram', { authenticated: true })
      const promises = responses.map(response =>
        client.post('/responses', {
          surveyId,
          enrollmentId,
          question_id: response?.question?.id,
          answerId: response?.id,
          response_content: response?.content?.length > 0
            ? response?.content?.map(elem => ({
              enrrollmentId: elem.enrollmentId,
              courses: elem.courses
            }))
            : []
        })
      )
      const results = await Promise.all(promises)
      if (responses.find(response => response.question.isRequired) && results.length === 0) {
        throw new BupError({ code: 'api/required-response-not-sended' })
      }
      if (results.length !== responses.length) {
        throw new BupError({ code: 'api/results-responses-missmatch' })
      }

      if (!results?.map(result => result?.data?.id).every(id => !!id)) {
        throw new BupError({ code: 'api/missing-result-id' })
      }
      setDataResponse(results.map(result => result.data))
      return results
    } catch (error) {
      setError(error)
      throw error
    } finally {
      setLoadingResponse(false)
    }
  }

  return {
    loadingResponse,
    dataResponse,
    error,
    saveAllResponsesByPage
  }
}
